<div class="info__item__text">
  <p>
    This agreement applies as between you, the User of this website and ESi
    holding Ltd trading as esi.one of Tallinn Estonia, <a
      href="/home"
      target="_blank">www.esi.one</a
    > (hereinafter "ESi.one" or "we"), the operator(s) of this website. Your agreement
    to comply with and be bound by these terms and conditions is deemed to occur
    upon your first use of the website. If you do not agree to be bound by these
    terms and conditions, you should stop using the website immediately.
  </p>
  <div class="legal__row">
    <div class="legal__row__head">Acceptance</div>
    <ul role="list">
      <li>
        Please read these Terms and Conditions, our privacy policy, and all
        applicable supplemental terms (collectively, the "terms") carefully, as
        they contain terms and conditions that impact your rights, obligations
        and remedies in connection with your use of the website and content. For
        example, the terms include:<br /><span class="legal__span"
          >- your obligation to comply with all applicable laws and regulations.<br
          /></span
        ><span class="legal__span"
          >- limitations of our liability to you; a<br /></span
        ><span class="legal__span"
          >- a requirement that you pursue claims or seek relief against us on
          an individual basis, rather than as a participant in any class or
          representative action or proceeding.</span
        >
      </li>
      <li>
        Your access to and use of the website is conditioned on your acceptance
        of and compliance with all applicable terms.
      </li>
      <li>We reserve the right to change these terms at any time.</li>
      <li>
        By accessing, browsing and/or using the website after updates to these
        terms have been posted, you agree to be bound by the updated terms.
      </li>
      <li>
        Your failure to comply with the Terms may result in the suspension or
        termination of your access to the Services and may subject you to civil
        and criminal penalties.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">General Conditions</div>
    <ul role="list">
      <li>
        We do not guarantee the accuracy, completeness, validity, or timeliness
        of information listed by us.
      </li>
      <li>
        Your access to and use of the website is conditioned on your acceptance
        of and compliance with all applicable terms.
      </li>
      <li>
        We make material changes to these terms and conditions from time to
        time, we may notify you either by prominently posting a notice of such
        changes or via email communication.
      </li>
      <li>
        The website is licensed to you on a limited, non-exclusive,
        non-transferable, non-sublicensable basis, solely to be used in
        connection with the Service for your private, personal, non-commercial
        use, subject to all the terms and conditions of this Agreement as they
        apply to the Service.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">License to use website</div>
    <ul role="list">
      <li>
        We may provide you with certain information because of your use of the
        website. Such information may include but is not limited to,
        documentation, data, or information developed by us, and other materials
        which may assist in your use of the website ("Our Materials").
      </li>
      <li>
        Subject to this Agreement, we grant you a non-exclusive, limited,
        non-transferable, and revocable license to use Our Materials solely in
        connection with your use of the website. Our Materials may not be used
        for any other purpose, and this license terminates upon your cessation
        of use of the website or at the termination of this Agreement.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">User Content</div>
    <ul role="list">
      <li>
        The website permits you to share and submit content etc. but you are
        solely responsible for the content provided by you.
      </li>
      <li>
        When sharing and submitting content to the website, please do not share
        and submit content that:<br /><span class="legal__span"
          >- contains ill-mannered, profane, abusive, racist, or hateful
          language or expressions, text, photographs, or illustrations that are
          pornographic or in poor taste, inflammatory attacks of a personal,
          racial, or religious nature.<br />- is defamatory, threatening,
          disparaging, grossly inflammatory, false, misleading, fraudulent,
          inaccurate, unfair, contains exaggeration or unsubstantiated claims.<br
          />- violates the privacy rights of any third party, is unreasonably
          harmful or offensive to any individual or community.<br />-
          discriminates on the grounds of race, religion, national origin,
          gender, age, marital status, sexual orientation, or disability, or
          refers to such matters in any manner prohibited by law.<br />-
          violates or inappropriately encourages the violation of any municipal,
          state, federal, or international law, rule, regulation, or ordinance.<br
          />- sends repeated messages and/or makes derogatory or offensive
          comments about another individual or repeats the same message under
          multiple emails or subjects.</span
        >
      </li>
      <li>
        Any submitted content that includes, but is not limited to the
        following, will be refused. If repeated violations occur, we reserve the
        right to cancel user access to the website without advanced notice.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Intellectual Property</div>
    <ul role="list">
      <li>
        You agree that the website and all Services provided by us are the
        property of ESi.one, including all copyrights, trademarks, trade
        secrets, patents, and other intellectual property ("Our IP"). You agree
        that we own all rights, title, and interest in and to the Our IP and
        that you will not use Our IP for any unlawful or infringing purpose. You
        agree not to reproduce or distribute Our IP in any way, including
        electronically or via registration of any new trademarks, trade names,
        service marks, or Uniform Resource Locators (URLs), without express
        written permission from us.
      </li>
      <li>
        To make the website and services available to you, you hereby grant us a
        royalty-free, non-exclusive, worldwide license to copy, display, use,
        broadcast, transmit and make derivative works of any content you
        publish, upload, or otherwise make available to the website. We claim no
        further proprietary rights in your Content.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">User Obligations</div>
    <ul role="list">
      <li>
        As a user of the website or Services, you may be asked to supply
        identifying information to us.
      </li>
      <li>
        You may also provide personal information, including, but not limited
        to, your name.
      </li>
      <li>
        You are responsible for ensuring the accuracy of this information. You
        must not share such identifying information with any third party, and if
        you discover that your identifying information has been compromised, you
        agree to notify us immediately in writing. An email notification will
        suffice. You are responsible for maintaining the safety and security of
        your identifying information as well as keeping us apprised of any
        changes to your identifying information. Providing false or inaccurate
        information or using the website or Services to further fraud or
        unlawful activity is grounds for immediate termination of this
        Agreement.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Acceptable Use</div>
    <ul role="list">
      <li>
        You agree not to use the website or Services for any unlawful purpose,
        or any purpose prohibited under this clause. You agree not to use the
        website or Services in any way that could damage the website, Services,
        or general business of ESi.one.
      </li>
      <li>
        You further agree not to use the website or Services:<br /><span
          class="legal__span"
          >- To harass, abuse, or threaten others or otherwise violate any
          person's legal rights.<br />- To violate any of our intellectual
          property rights or any third party.<br />-To upload or otherwise
          disseminate any computer viruses or other software that may damage the
          property of another.<br />-To perpetrate any fraud.<br />-To publish
          or distribute any obscene or defamatory material.<br />-To publish or
          distribute any material that incites violence, hate, or discrimination
          towards any group.<br />-To unlawfully gather information about
          others.<br />-You are strictly prohibited from using the website or
          any of our Services for illegal spam activities, including gathering
          email addresses and personal information from others or sending any
          mass commercial emails.</span
        >
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Reverse engineering and security</div>
    <ul role="list">
      <li>
        You agree not to undertake any of the following actions:<br /><span
          class="legal__span"
          >- Reverse engineer or attempt to reverse engineer or disassemble any
          code or software from or on the website or Services.<br />-Violate the
          security of the website or Services through any unauthorized access,
          circumvention of encryption or other security tools, data mining, or
          interference to any host, user, or network.</span
        >
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Indemnification</div>
    <p>
      The website is provided for communication purposes only. You acknowledge
      and agree that any information posted on our website is not intended to be
      legal advice, financial advice, and no fiduciary relationship has been
      created between you and us. You further agree that your purchase of any of
      the website on the website is at your own risk. We do not assume
      responsibility or liability for any advice or other information given on
      the website.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Assumption of Risk</div>
    <p>
      You agree to defend and indemnify us and any of our affiliates (if
      applicable) and hold us harmless against any legal claims and demands,
      including reasonable legal fees, which may arise from or relate to your
      use or misuse of the website or Services, your breach of this Agreement,
      or your conduct or actions. You agree that we shall be able to select its
      legal counsel and may participate in its defence if we wish.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Exclusion of liability</div>
    <ul role="list">
      <li>
        You understand and agree that we (A) do not guarantee the accuracy,
        completeness, validity, or timeliness of information listed by us or any
        third parties; and (B) shall not be responsible for any materials posted
        by us or any third party. You shall use your judgment, caution, and
        common sense in evaluating any prospective methods or offers and any
        information provided by us or any third party.
      </li>
      <li>
        Further, we shall not be liable for direct, indirect consequential, or
        any other form of loss or damage that may be suffered by a user using
        the ESi.one website including loss of data or information or any kind of
        financial or physical loss or damage.
      </li>
      <li>
        In no event shall ESi.one, nor its Owner, directors, employees,
        partners, agents, suppliers, or affiliates, be accountable for any
        indirect, incidental, special, eventful, or exemplary costs, including
        without limitation, loss of proceeds, figures, usage, goodwill, or other
        intangible losses, consequential from (i) your use or access of or
        failure to access or use the Service; (ii) any conduct or content of any
        third party on the Service; (iii) any content attained from the Service;
        and (iv) unlawful access, use or alteration of your transmissions or
        content, whether or not based on guarantee, agreement, domestic wrong
        (including carelessness) or any other lawful concept, whether or not
        we've been aware of the possibility of such damage, and even if a cure
        set forth herein is originated to have futile of its important purpose.
      </li>
      <li>
        We are not liable for any damages that may occur to you because of your
        use of the website or Services, to the fullest extent permitted by law.
        This section applies to any claims by you, including, but not limited
        to, lost profits or revenues, consequential or punitive damages,
        negligence, strict liability, fraud, or torts of any kind.
      </li>
    </ul>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Third-party links and content</div>
    <p>
      We may occasionally post links to third-party websites or other websites.
      You agree that we are not responsible for any loss or damage caused
      because of your use of any third-party website linked to or from Our
      website.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Modification and variation</div>
    <p>
      We may, from time to time and at any time without notice to you, modify
      this Agreement. You agree that we have the right to modify this Agreement
      or revise anything contained herein. You further agree that all
      modifications to this Agreement are in full force and effect immediately
      upon posting on the website and that modifications or variations will
      replace any prior version of this Agreement unless prior versions are
      specifically referred to or incorporated into the latest modification or
      variation of this Agreement.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Service interruptions</div>
    <p>
      We may need to interrupt your access to the website to perform maintenance
      or emergency website on a scheduled or unscheduled basis. You agree that
      your access to the website may be affected by unanticipated or unscheduled
      downtime, for any reason, but that we shall have no liability for any
      damage or loss caused because of such downtime.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">Term, Termination and Suspension</div>
    <p>
      We may terminate this Agreement with you at any time for any reason, with
      or without cause. We specifically reserve the right to terminate this
      Agreement if you violate any of the terms outlined herein, including, but
      not limited to, violating the intellectual property rights of us or a
      third party, failing to comply with applicable laws or other legal
      obligations, and/or publishing or distributing illegal material. At the
      termination of this Agreement, any provisions that would be expected to
      survive termination by their nature shall remain in full force and effect.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">No Warranties</div>
    <p>
      You agree that your use of the website and Services is at your sole and
      exclusive risk and that any Services provided by us are on an "As Is"
      basis. We hereby expressly disclaim any express or implied warranties of
      any kind, including, but not limited to the implied warranty of fitness
      for a particular purpose and the implied warranty of merchantability. We
      make no warranties that the website or Services will meet your needs or
      that the website or Services will be uninterrupted, error-free, or secure.
      We also make no warranties as to the reliability or accuracy of any
      information on the website or obtained through the Services. You agree
      that any damage that may occur to you, through your computer system, or
      because of the loss of your data from your use of the website or Services
      is your sole responsibility and that we are not liable for any such damage
      or loss.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head">General Provisions</div>
    <ul role="list">
      <li>
        You understand and agree that we (A) do not guarantee the accuracy,
        completeness, validity, or timeliness of information listed by us or any
        third parties; and (B) shall not be responsible for any materials posted
        by us or any third party. You shall use your judgment, caution, and
        common sense in evaluating any prospective methods or offers and any
        information provided by us or any third party.
      </li>
      <li>
        Further, we shall not be liable for direct, indirect consequential, or
        any other form of loss or damage that may be suffered by a user using
        the ESi.one website including loss of data or information or any kind of
        financial or physical loss or damage.
      </li>
      <li>
        If any part or sub-part of this Agreement is held invalid or
        unenforceable by a court of law or competent arbitrator, the remaining
        parts and sub-parts will be enforced to the maximum extent possible. In
        such a condition, the remainder of this Agreement shall continue in full
        force.
      </li>
      <li>
        If we fail to enforce any provision of this Agreement, this shall not
        constitute a waiver of any future enforcement of that provision or any
        other provision. Waiver of any part or sub-part of this Agreement will
        not constitute a waiver of any other part or sub-part.
      </li>
      <li>
        Headings of parts and sub-parts under this Agreement are for convenience
        and organization, only. Headings shall not affect the meaning of any
        provisions of this Agreement.
      </li>
      <li>
        No agency, partnership, or joint venture has been created between the
        Parties because of this Agreement. No Party has any authority to bind
        the other to third parties.
      </li>
      <li>
        We are not liable for any failure to perform due to causes beyond its
        reasonable control including, but not limited to, acts of God, acts of
        civil authorities, acts of military authorities, riots, embargoes, acts
        of nature, and natural disasters, and other acts which may be due to
        unforeseen circumstances.
      </li>
      <li>
        The terms herein will be governed by and construed by the laws of
        Estonia without giving effect to any principles of conflicts of law. The
        Courts of Estonia shall have exclusive jurisdiction over any dispute
        arising from the use of the website.
      </li>
    </ul>
  </div>
</div>
<style>
  p{
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  </style>
